import styled from "styled-components"

export default function ProductDetailContentBlock({ children }) {
  return <Block>{children}</Block>
}

const Block = styled.div`
  position: relative;
  padding: 0 calc(100vw * (20 / 375));
`
